var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var FundingTrendsIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 30,
    glyphHeight: 48
  }), React.createElement("path", {
    d: "M12.2783 47.4678V42.4613C6.77999 41.9695 3.13081 39.7367 0.406219 36.7465L5.31442 32.281C7.37999 34.4547 9.93737 35.9301 12.9865 36.3629V26.5662C4.82261 24.8744 1.49802 21.2842 1.49802 16.0023C1.49802 10.2875 5.2554 6.47112 12.2783 5.65473V0.539978H18.4849V5.65473C22.8423 6.14653 26.0587 7.8285 28.4488 10.5531L23.4915 15.0187C22.1833 13.5433 20.4423 12.3531 17.8259 11.7531V20.7924C25.4488 22.5334 29.098 25.6416 29.098 31.1892C29.098 36.7367 25.7243 41.0449 18.4751 42.2449V47.4678H12.2685H12.2783ZM12.9865 19.7006V11.6449C10.2128 12.1859 9.01278 13.6613 9.01278 15.7859C9.01278 17.9105 10.2128 18.9433 12.9865 19.7105V19.7006ZM17.8357 27.6482V36.2547C20.3931 35.5465 21.5931 33.8547 21.5931 31.7892C21.5931 30.2056 20.9341 28.5728 17.8357 27.6482Z"
  }));
};
export var FundingTrendsIconGlyph = function (props) {
  return React.createElement(FundingTrendsIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};